<template>
  <div class="multiple-percentage-input clearfix">
    <div
      v-if="!hide"
      class="form-group row"
      :class="{ 'has-feedback': isDirty }"
    >
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="lotsBasedContainer">
              <label class="lotsBasedLabel">
                Use Lots Based Calculation
              </label>
              <input
                type="checkbox"
                name="useLotsBasedCalculation"
                v-model="useLotsBasedCalculation"
                class="lotsBasedCheckbox"
              />
            </div>
            <template v-for="(section, index) in sections">
              <percentage-named-input
                :highlightValidation="isValid"
                :key="index"
                :onChange="validate"
                :options="section"
                v-model="section.value"
                ref="fields"
                @onOCNameInput="handleOnOCNameInput"
                :useLotsBasedCalculation="useLotsBasedCalculation"
              ></percentage-named-input>
            </template>
          </div>
        </div>
        <div class="row" v-if="!useLotsBasedCalculation">
          <div class="col-sm-9 offset-sm-3">
            <span :class="validationClass" v-show="validationMessage">
              {{ validationMessage }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage,
  formControlValidationClass
} from "@/util/helpers";
import PercentageNamedInput from "@/components/inputs/PercentageNamedInput";

export default {
  name: "MultiplePercentageInput",
  components: {
    PercentageNamedInput
  },
  props: {
    value: {
      type: [Array]
    },
    options: {
      type: Object,
      default() {
        return {
          label: "",
          totalPrice: false
        };
      }
    }
  },
  data() {
    return {
      isValid: false,
      isDirty: false,
      watcher: false,
      hide: false,
      sections: [],
      doesNotSumToTotal: false,
      nullValueExist: false,
      total: 0,
      useLotsBasedCalculation: false
    };
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    formControlValidationClass,
    invalidMessage() {
      if (this.nullValueExist) {
        return `Cannot have 0%!`;
      } else if (this.doesNotSumToTotal) {
        return `Total does not add up to 100%! Current total is ${this.total}%. `;
      } else {
        return "error";
      }
    }
  },
  mounted() {
    if (this.options.hidden) this.hide = true;
    if (this.options.useLotsBasedCalculation)
      this.useLotsBasedCalculation = true;
    if (this.value.length > 1) {
      for (let i = 0; i !== this.value.length; ++i) {
        this.sections.push({
          // ocNameValue is the actual value of the input element,
          // it is the value you get if `e.target.value`
          ocNameValue:
            typeof this.value[i] !== "object" ? "" : this.value[i].ocNameValue,
          value:
            typeof this.value[i] !== "object"
              ? this.value[i]
              : this.useLotsBasedCalculation
              ? this.value[i].lots
              : this.value[i].amount,
          label: this.options.label + " " + (i + 1),
          name: i,
          // ocName is the name attribute of the input element
          ocName:
            typeof this.value[i] !== "object"
              ? `ocName${i}`
              : this.value[i].ocName
        });
      }
    }
    this.validate();
  },
  methods: {
    validate(sections = this.sections) {
      if (!this.hide) {
        this.isDirty = true;
        let values = [];
        let total = 0;
        let nullValueExist = false;
        for (let i = 0; i !== sections.length; i++) {
          let val = parseFloat(sections[i].value);
          values.push({
            amount: val,
            num: i + 1,
            ocName: sections[i].ocName || `ocName` + `${i + 1}`,
            ocNameValue: sections[i].ocNameValue || `OC ${i + 1}`,
            useLotsBasedCalculation: this.useLotsBasedCalculation,
            lots: sections[i].lots
          });
          total += isNaN(val) ? 0 : val;
          if (val === 0) {
            nullValueExist = true;
          }
        }
        this.total = total;
        this.$emit("input", values);
        if (this.useLotsBasedCalculation) {
          this.total = 100;
          this.nullValueExist = false;
          this.isValid = true;
          this.doesNotSumToTotal = false;
          return;
        }
        if (total !== 100) {
          this.doesNotSumToTotal = true;
          this.nullValueExist = false;
          this.isValid = false;
        } else if (nullValueExist) {
          this.nullValueExist = true;
          this.isValid = false;
        } else {
          this.doesNotSumToTotal = false;
          this.nullValueExist = false;
          this.isValid = true;
        }
      } else {
        this.isValid = true;
      }
    },
    runWatcher(val, name) {
      if (this.options.watchers.includes(name)) {
        if (val || val === false) {
          switch (name) {
            case "numberOfOC":
              val = parseInt(val);
              let sections = [];
              if (val > 1) {
                this.hide = false;
                for (let i = 0; i !== val; ++i) {
                  sections.push({
                    value:
                      i < this.sections.length ? this.sections[i].value : 0,
                    label: this.options.label + " " + (i + 1),
                    name: i,
                    ocName:
                      typeof this.value[i] !== "object"
                        ? `ocName${i + 1}`
                        : this.value[i].ocName,
                    ocNameValue:
                      typeof this.value[i] !== "object"
                        ? ""
                        : this.value[i].ocNameValue
                  });
                }
              } else {
                this.hide = true;
              }
              this.sections = sections;
              this.validate();
              break;
            default:
              break;
          }
        } else {
          this.validate("");
          this.isDirty = false;
        }
      }
    },
    handleOnOCNameInput(ocNameValue, inputName) {
      console.log(`payload ${ocNameValue}`);
      console.log(`input name: ${inputName}`);
      const section = this.sections.find(s => s.ocName == inputName);
      section.ocNameValue = ocNameValue;
      this.validate();
    }
  }
};
</script>
<style scoped>
.lotsBasedContainer {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.lotsBasedCheckbox {
  --checkbox-width: 15px;
  width: var(--checkbox-width);
  height: var(--checkbox-width);
  margin-left: 10px;
}
.lotsBasedLabel {
  width: 25%;
}
@media only screen and (max-width: 992px) {
  .lotsBasedLabel { width: 100%; }
  .lotsBasedCheckbox { margin-left: 0;}
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/MultiplePercentageInput.vue